import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetBlockadeMonthExceptionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import momencik from '../../../common/momencik';
import { TKeys, useTranslation } from '../../../common/hooks/useTranslation';

interface BlockedMonthExceptionSearchProps {
  getData?: GridGetterFunction;
  getCount?: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  isNavView?: boolean;
  showFilter?: boolean;
  emptyGridMessage?: string;
}

export const blockadeMonthExceptionForGrid = (
  t: TFunction<'projectLng', 'projectLng'>,
  tk: TKeys<'projectLng'>,
  blockadeMonthException: GetBlockadeMonthExceptionDto,
) => {
  return {
    key: blockadeMonthException.id,
    values: {
      sale_yes_no: blockadeMonthException.isSalesUnblocked
        ? t(tk.common.yes)
        : '',
      purchase_yes_no: blockadeMonthException.isPurchaseUnblocked
        ? t(tk.common.yes)
        : '',
      'project.number': blockadeMonthException.project?.number,
      'project.name': blockadeMonthException.project?.name,
      'creator.name': blockadeMonthException.creator?.name,
      'blockadeMonthException.date': momencik(
        blockadeMonthException.date,
        'YYYY-MM',
      ),
      'blockadeMonthException.dateToDelete': momencik(
        blockadeMonthException.dateToDelete,
      ),
    },
    isInactive: !blockadeMonthException.active,
  };
};

export const BlockadeMonthExceptionSearch: React.FC<
  BlockedMonthExceptionSearchProps
> = props => {
  const { t, tk } = useTranslation('projectLng');
  const columns: GridColumn[] = [
    { header: t(tk.prLang.projectNumber), property: 'project.number' },
    { header: t(tk.prLang.projectName), property: 'project.name' },
    { header: t(tk.common.month), property: 'blockadeMonthException.date' },
    { header: t(tk.projects.salesUnblockade), property: 'sale_yes_no' },
    { header: t(tk.projects.purchaseUnblockade), property: 'purchase_yes_no' },
    { header: t(tk.common.creator), property: 'creator.name' },
    {
      header: t(tk.projects.dateToDeleteBlockade),
      property: 'blockadeMonthException.dateToDelete',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      refresh={props.refresh}
      initialOrderColumn="project.number"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={
        props.emptyGridMessage || t(tk.projects.noBlockadesExceptions)
      }
      onRowClick={props.onRowClick}
      withHistory={true}
      showFilter={props.showFilter}
      withFilterInColumns={true}
    />
  );
};
